/**
 * Payroll (RRHH / Nómina RD) — página standalone.
 * Reutiliza `PayrollTab` del hub Amelia, en su propia URL.
 */
import { PageContainer, PageHeader } from "@/components/PageHeader";
import { PayrollTab } from "@/pages/AmeliaHub";

export default function Payroll() {
  return (
    <PageContainer>
      <PageHeader
        title="Nómina (RRHH)"
        subtitle="Empleados, nóminas, TSS/ISR, prestaciones laborales, vacaciones y regalía pascual."
        testid="payroll-header"
      />
      <div className="mt-4">
        <PayrollTab />
      </div>
    </PageContainer>
  );
}
